import { useTranslation } from 'react-i18next';
import { useSessionProvider } from '../../provider/sessionContext.tsx';
import { useGetLegalRequirements } from './queries/useGetLegalRequirements.tsx';
import { DEFAULT_PUBLIC_LEGAL_DOCS, resolveLegalContentUrl } from './Legal.ts';

/**
 * Resolves the public URL of the legal document of the given type for the current
 * user's role-based pathway. Falls back to the Patient documents when the user is
 * not authenticated (e.g. the registration form).
 */
export function useLegalDocumentUrl(
    documentType: 'TermsOfUse' | 'PrivacyNotice',
    opened: boolean,
): string {
    const { i18n } = useTranslation();
    const { currentUser } = useSessionProvider();

    const { data } = useGetLegalRequirements(opened && !!currentUser);

    const template =
        data?.documents.find((doc) => doc.documentType === documentType)?.contentPathTemplate ??
        DEFAULT_PUBLIC_LEGAL_DOCS[documentType];

    return resolveLegalContentUrl(template, i18n.language);
}
